var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-chart"},[_c('div',{staticClass:"label-chart__color"},[_c('div',{staticClass:"label-chart__square",style:({"background-color": _vm.getColor})})]),_c('div',{staticClass:"label-chart__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }